/* eslint-disable no-useless-escape */

export const EMAIL_REGEX = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export const PHONE_NUMBER_REGEX = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

const luhnAlgo = (value) => {

  if (!value) return false;

  const arr = [...value];
  let sum = 0;
  const n = arr?.length;

  for (let i = 0; i < n; i++) {
    arr[i] = parseInt(arr[i]);
  }

  for (let i = 1; i < n; i = i + 2) {
    const v = arr[n - 1 - i] * 2;
    if (v > 9) {
      arr[n - 1 - i] = v - 9;
    } else {
      arr[n - 1 - i] = v;
    }
  }

  arr?.forEach((item) => sum += item);

  if (sum % 10 === 0) return true;
  return false;
};

export const validator = (value, type, luhn = false, isPhoneNumber = false) => {

  if (isPhoneNumber) return value.match(PHONE_NUMBER_REGEX);

  if (luhn) return luhnAlgo(value);

  if (type === 'text') return value?.length > 0;

  if (type === 'email') return value.match(EMAIL_REGEX);

  if (type === 'number') return !isNaN(value) && value?.length <= 20 && value?.length >= 1;

  return true;
};

